// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "../static-" + (["1.12172"][{"7565":0}[chunkId]] || "1.12177") + "/" + chunkId + ".js";
};